export let hideBreadCrumbsItem = [
	{
		title: 'admin',
		route: 'admin/admin',
	},
	{
		title: 'tariff',
		route: '',
	},
	{
		title: 'finance',
		route: '',
	},
	{
		title: 'payment',
		route: '',
	},
	{
		title: 'media',
		route: '',
	},
	{
		title: 'category',
		route: '',
	},
	{
		title: 'studio',
		route: 'studio',
	},
	{
		title: 'tickets',
		route: '',
	},
	{
		title: 'active',
		route: '',
	},
	{
		title: 'settings',
		route: '',
	},
	{
		title: 'block',
		route: '',
	},
	{
		title: 'manage',
		route: '',
	},
	{
		title: 'handle-studios',
		route: 'studio',
	},
	{
		title: 'view',
		hide: true,
	},
];
